import "./taskManager.css";
import Task from "../Task/Task";
import { useState, useEffect } from "react";
import { collection, query, orderBy, onSnapshot } from "firebase/firestore";
import { db } from "../../../firebase";
import AddTask from "../AddTask/AddTask";

function TaskManager() {
  const [openAddModal, setOpenAddModal] = useState(false);
  const [tasks, setTasks] = useState([]);

  /* function to get all tasks from firestore in realtime */
  useEffect(() => {
    const taskColRef = query(
      collection(db, "ilanlar"),
      orderBy("created", "desc")
    );
    onSnapshot(taskColRef, (snapshot) => {
      setTasks(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, []);

  return (
    <div className="taskManager">
      <div className="taskManager__container">
        <button onClick={() => setOpenAddModal(true)}>Create Post +</button>
        <div className="taskManager__tasks">
          <div className="dataGrid">
            <table>
              <thead>
                <tr>
                  <th data-type="text-short">
                    Marka <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-short">
                    Product <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-short">
                    Min Follower <span className="resize-handle"></span>
                  </th>

                  <th data-type="text-short">
                    Min Payment <span className="resize-handle"></span>
                  </th>

                  <th data-type="text-long">
                    Other <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-long">
                    Onay <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-long">
                    Edit <span className="resize-handle"></span>
                  </th>
                  <th data-type="text-long">
                    Delete <span className="resize-handle"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((task) => (
                  <Task
                    id={task.id}
                    key={task.id}
                    completed={task.data.completed}
                    marka={task.data.marka}
                    product={task.data.product}
                    minPay={task.data.minPay}
                    minFollowers={task.data.minFollowers}
                  />
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {openAddModal && (
        <AddTask onClose={() => setOpenAddModal(false)} open={openAddModal} />
      )}
    </div>
  );
}

export default TaskManager;
